import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { api } from "@/lib/api";

let cached = null;
const loadTop = () => (cached ||= api.get("/supporters/top").then(({ data }) => data.user_id).catch(() => { cached = null; return null; }));

export function TopCrown({ userId }) {
  const [top, setTop] = useState(null);
  useEffect(() => { let on = true; loadTop().then((id) => on && setTop(id)); return () => { on = false; }; }, []);
  if (!top || top !== userId) return null;
  return (
    <span title="Top Unterstützer" data-testid={`top-crown-${userId}`} className="inline-flex shrink-0 -rotate-12 sp-heart-badge">
      <Heart className="w-4 h-4 text-rose-500 stroke-white drop-shadow-[0_0_4px_rgba(244,63,94,.7)]" fill="currentColor" strokeWidth={1.5} />
    </span>
  );
}
